<div class="modal-header">
  <h4 class="modal-title">Agregar @if(esDelegacion){ delegaci&oacute;n } @else { usuario }</h4>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="mb-3 row">
      <label for="usuarioFormControl" class="col-sm-5 col-form-label">Usuario:</label>
      <div class="col-sm-7">
        <input id="usuarioFormControl" class="form-control" maxlength="50" type="text" placeholder="Buscar usuario"
          formControlName="usuarioFormControl" [inputFormatter]="formatterUsuario" [resultFormatter]="formatterUsuario"
          (selectItem)="selectUsuario($event)" [ngbTypeahead]="searchUsuario" (blur)="verificarUsuarioSeleccionado()" />
        <loading-text-spinner *ngIf="obteniendoUsuarios" [error]="errorUsuarios" message="Obteniendo usuarios..."
          color="primary"></loading-text-spinner>
        <div class="alert alert-danger mt-2"
          *ngIf="form.get('usuarioFormControl')?.touched && form.get('usuarioFormControl')?.invalid">
          Requerido
        </div>
      </div>
    </div>

    <ng-container *ngIf="esDelegacion">
      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <label class="form-label">Fecha Desde:</label>
          <div class="input-group">
            <input type="date" class="form-control" placeholder="aaaa-mm-dd" formControlName="fechaDesdeFormControl"
              ngbDatepicker [(ngModel)]="modelDesde" #d="ngbDatepicker" ngbTooltip="Seleccione una fecha." readonly />
            <button class="btn btn-secondary" (click)="d.toggle()">
              <i class="fa fa-calendar"></i>
            </button>
          </div>
          <div class="alert alert-danger mt-2"
            *ngIf="form.get('fechaDesdeFormControl')?.touched && form.get('fechaDesdeFormControl')?.invalid">
            Requerido
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">Fecha Hasta:</label>
          <div class="input-group">
            <input type="date" class="form-control" placeholder="aaaa-mm-dd" formControlName="fechaHastaFormControl"
              ngbDatepicker [(ngModel)]="modelHasta" #h="ngbDatepicker" ngbTooltip="Seleccione una fecha." readonly />
            <button class="btn btn-secondary" (click)="h.toggle()">
              <i class="fa fa-calendar"></i>
            </button>
          </div>
          <div class="alert alert-danger mt-2"
            *ngIf="form.get('fechaHastaFormControl')?.touched && form.get('fechaHastaFormControl')?.invalid">
            Requerido
          </div>
          <div class="alert alert-danger mt-2"
            *ngIf="form.errors?.fechaInvalida && form.get('fechaHastaFormControl')?.touched">
            La fecha hasta no puede ser menor que la fecha desde.
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <label for="motivoFormControl" class="form-label">Motivo:</label>
        <div>
          <textarea id="motivoFormControl" class="form-control" rows="3" placeholder="Ingrese el motivo"
            formControlName="motivoFormControl"></textarea>
          <div class="alert alert-danger mt-2"
            *ngIf="form.get('motivoFormControl')?.touched && form.get('motivoFormControl')?.invalid">
            Requerido
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="onGuardar()"
    [disabled]="form.invalid || guardandoUsuario"><span *ngIf="!guardandoUsuario">Guardar</span>
    <div *ngIf="guardandoUsuario" class="d-flex align-items-center">
      <div class="spinner-border text-light spinner-border-sm" role="status"></div>
      <span>Guardando...</span>
    </div>
  </button>

  <button type="button" class="btn btn-secondary" (click)="onCancelar()">Cancelar</button>
</div>